<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Pullman’s Geologic Beginnings</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. The Railroad Era Begins</a></p>
<p class="toc"><a href="#/Chapter3#C3">3. George Pullman in New York</a></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Raising Chicago and Pullman’s First Sleepers</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Gold Fever</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Improving the Sleeper Car</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Pullman Palace Car Company</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Pullman Porters and Maids</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. West of Lake Calumet Before Pullman</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Pullman: Industrial and Commercial Assets</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Pullman: Residences and Early Residents</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Unrest, Annexation and Strike</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Repercussions</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Pullman Porters Organize</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. The Pullman Company and the Town 1897–1945</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. The Postwar Years</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Citizen Involvement and Pride, Restoration and Recognition</span></p>
<p class="toc1"><span href="#/Appendix" title="Link target outside of Sample">Appendix: The Pullman Building Downtown</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?cf7442da